// extracted by mini-css-extract-plugin
export default {"wrapper":"SummaryBanner_wrapper__3xH5M","label":"SummaryBanner_label__KrqAk","value":"SummaryBanner_value__M9F6V"};